import { endpoints, baseurl } from "../Utils/Constants";

export const getAllOrganizationAnalytics = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_ORG_ANALYTICS, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching organization analytics:", error);
        throw error;
    }
};

export const getOrganizationAnalytics = async (token, organizationId) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ORG_ANALYTICS + organizationId, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching organization analytics:", error);
        throw error;
    }
};

export const getOrganizationAnalyticsByDates = async (token, startDate, endDate, facilityName) => {
    try {
        const s = encodeURIComponent(startDate || '');
        const e = encodeURIComponent(endDate || '');
        const f = encodeURIComponent(facilityName || '');
        const url = baseurl + endpoints.GET_ORG_ANALYTICS_BY_DATE.replace('{start_date}', s).replace('{end_date}', e).replace('{facility_name}', f);
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching organization analytics by dates:", error);
        throw error;
    }
};

export const getAllProductivityAnalytics = async (token, organizationId, startDate, endDate) => {
    try {
        const org = encodeURIComponent(organizationId || '');
        const s = encodeURIComponent(startDate || '');
        const e = encodeURIComponent(endDate || '');
        const url = baseurl + endpoints.GET_ALL_ORG_PRODUCTIVITY.replace('{organization_id}', org).replace('{start_date}', s).replace('{end_date}', e);
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching all productivity analytics:", error);
        throw error;
    }
};

export const getAllOrgPatientAnalytics = async (token, organizationId, startDate, endDate, facilityName = '') => {
    try {
        const org = encodeURIComponent(organizationId || '');
        const s = encodeURIComponent(startDate || '');
        const e = encodeURIComponent(endDate || '');
        let url = baseurl + endpoints.GET_ALL_ORG_PATIENTS.replace('{organization_id}', org).replace('{start_date}', s).replace('{end_date}', e);
        if (facilityName) {
            const f = encodeURIComponent(facilityName);
            // append facility_name as an extra query param expected by backend
            url += `&facility_name=${f}`;
        }
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching all patient analytics:", error);
        throw error;
    }
};

export const getAllPatientAnalytics = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_PATIENT, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching all patient analytics:", error);
        throw error;
    }
};

export const getAllProviderProductivityAnalytics = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_PROVIDER_PRODUCTIVITY, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching all provider productivity analytics:", error);
        throw error;
    }
};

// options: { startDate, endDate, facilityName, sortBy, sortDir, includeUnmatched, limit, offset }
export const getProviderProductivityList = async (token, organizationId, options = {}) => {
    try {
        const org = encodeURIComponent(organizationId || '');
        let url = baseurl + endpoints.GET_PROVIDER_PRODUCTIVITY_LIST.replace('{organization_id}', org);
        const { startDate, endDate, facilityName, sortBy, sortDir, includeUnmatched, limit, offset } = options;
        if (startDate) url += `&start_date=${encodeURIComponent(startDate)}`;
        if (endDate) url += `&end_date=${encodeURIComponent(endDate)}`;
        if (facilityName) url += `&facility_name=${encodeURIComponent(facilityName)}`;
        if (sortBy) url += `&sort_by=${encodeURIComponent(sortBy)}`;
        if (sortDir) url += `&sort_dir=${encodeURIComponent(sortDir)}`;
        if (includeUnmatched === false) url += `&include_unmatched=false`;
        if (limit) url += `&limit=${encodeURIComponent(limit)}`;
        if (offset) url += `&offset=${encodeURIComponent(offset)}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching provider productivity list:", error);
        throw error;
    }
};

export const getProviderAnalytics = async (token, organizationId, providerName, startDate, endDate) => {
    try {
        const org = encodeURIComponent(organizationId || '');
        const p = encodeURIComponent(providerName || '');
        let url = baseurl + endpoints.GET_PROVIDER_ANALYTICS.replace('{organization_id}', org).replace('{provider_name}', p);
        if (startDate) url += `&start_date=${encodeURIComponent(startDate)}`;
        if (endDate) url += `&end_date=${encodeURIComponent(endDate)}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching provider analytics:", error);
        throw error;
    }
};

export const getProviderAnalyticsTrend = async (token, organizationId, providerName, startDate, endDate, granularity = 'month') => {
    try {
        const org = encodeURIComponent(organizationId || '');
        const p = encodeURIComponent(providerName || '');
        let url = baseurl + endpoints.GET_PROVIDER_ANALYTICS_TREND.replace('{organization_id}', org).replace('{provider_name}', p);
        url += `&start_date=${encodeURIComponent(startDate || '')}&end_date=${encodeURIComponent(endDate || '')}&granularity=${encodeURIComponent(granularity)}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching provider analytics trend:", error);
        throw error;
    }
};

export const getProviderBenchmark = async (token, organizationId, providerName, startDate, endDate) => {
    try {
        const org = encodeURIComponent(organizationId || '');
        const p = encodeURIComponent(providerName || '');
        let url = baseurl + endpoints.GET_PROVIDER_BENCHMARK.replace('{organization_id}', org).replace('{provider_name}', p);
        if (startDate) url += `&start_date=${encodeURIComponent(startDate)}`;
        if (endDate) url += `&end_date=${encodeURIComponent(endDate)}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching provider benchmark:", error);
        throw error;
    }
};

export const getOrganizationsRevenue = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ORGANIZATIONS_REVENUE, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching organizations revenue:", error);
        throw error;
    }
};

export const getOrganizationRevenue = async (token, organizationId, startDate, endDate) => {
    try {
        const url = baseurl + endpoints.GET_ORGANIZATION_REVENUE
            .replace('{organization_id}', encodeURIComponent(organizationId || ''))
            .replace('{start_date}', encodeURIComponent(startDate || ''))
            .replace('{end_date}', encodeURIComponent(endDate || ''));
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "ngrok-skip-browser-warning": "true",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching organization revenue:", error);
        throw error;
    }
};
